export default __webpack_public_path__ + "f4a071b21f686fcf9fdefa396d218500.svg";